import { initSentryMiddleware } from '../../logging';

import actionCapture from './action-capture';
import sagas, { runSagaMiddleware } from './sagas';
import routes from './routes';

export const postApply = () => {
  runSagaMiddleware();
};

const middlewares = {
  initSentryMiddleware,
  sagas,
  routes,
  actionCapture
};

export default middlewares;
